import { z } from 'zod';

export const UserUploadUrl = z.object({
  url: z.string(),
  uploadId: z.string(),
});

export type UserUploadUrl = z.infer<typeof UserUploadUrl>;
